import { gql, useQuery } from '@apollo/client';
export const USE_PAY_ANYONE_TOKEN_QUERY = gql`
  query UsePayAnyoneTokenQuery($token: String!) {
    unauthenticated {
      p2p {
        pay_anyone(token: $token) {
          __typename
          ... on PayAnyoneWithExternalCard {
            sender {
              name
            }
          }
          ... on PayAnyoneFetchError {
            error_id
            error_header
            error_body
          }
          ... on StepUpRequiredError {
            title
            message
            challenge_context
          }
        }
      }
    }
  }
`;

export const usePayAnyoneTokenQuery = (pfToken, options) => {
  const { data, error, loading } = useQuery(USE_PAY_ANYONE_TOKEN_QUERY, {
    variables: { token: pfToken },
    ...options,
  });

  return {
    data,
    error,
    loading,
  };
};
